/**
 * The report kinds the Selling Partner API fetcher pulls for itself, in the
 * order the nightly cycle runs them.
 *
 * One list for both sides: the API's fetcher (`spapi/reports.ts`, which checks
 * each entry is a known report kind and gives each one its report spec) and the
 * Imports page's chooser (which lists these under "Manual (normally fetched
 * automatically)"), so the two can never disagree about what is fetched.
 */
export const FETCHABLE_REPORT_KINDS = [
  'all_listings',
  'all_orders',
  'ledger_detail',
  'fba_inventory',
  'inventory_health',
  'sales_traffic_json',
] as const;

export type FetchableReportKind = (typeof FETCHABLE_REPORT_KINDS)[number];
